import { Dropdown, Toggle } from "@carbon/react";
import PropTypes from "prop-types";

const SelectReportDate = ({
  id,
  availableReports,
  selectedReport,
  label,
  onChange,
  useActual,
  onChangeuseActual,
  light
}) => (
  <section className="cds--grid select-report-date__container">
    <div className="cds--row">
      <div className="cds--col select-report-date__selection_boxes">
        <div>
          <h4>Viewing data for</h4>
        </div>
        <div className="select-report-date__dropdown">
          <Dropdown
            id={id}
            items={availableReports}
            selectedItem={selectedReport}
            label={label}
            onChange={({ selectedItem }) => onChange(selectedItem)}
            light={light}
          />
        </div>
        <div>
          <Toggle
            id="use-actual"
            toggled={useActual}
            onToggle={value => onChangeuseActual(value)}
            labelText="Use Actual Data"
            hideLabel
          />
        </div>
      </div>
    </div>
  </section>
);

SelectReportDate.propTypes = {
  id: PropTypes.string.isRequired,
  availableReports: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedReport: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  useActual: PropTypes.bool,
  onChangeuseActual: PropTypes.func,
  light: PropTypes.bool
};

SelectReportDate.defaultProps = {
  label: "Available Reports",
  useActual: false,
  onChangeuseActual: null,
  light: false
};

export default SelectReportDate;
